import { KText } from '@/ui-library/components/text';
import { Box, Flex, Image, Link, VStack } from '@chakra-ui/react';
import { LinkExternal01 } from '@kula-ai/icons/outline/LinkExternal01';

export const VonqSelectedImages = ({ value, options = [], label }) => {
  // Find the selected option by value
  const selectedOption = options.find(opt => opt.value === value);
  
  // Only render if selectedOption has images
  if (!selectedOption?.images?.length) return null;

  return (
    <Box mt={3} p={3} bg="gray.50" borderRadius="md" border="1px" borderColor="gray.200">
      <KText size="sm-medium" color="secondary-900" mb={2}>
        {label} Preview:
      </KText>
      <VStack align="flex-start" spacing={3}>
        {selectedOption.images.map((imageObj, index) => {
          const image = imageObj.image;
          if (!image) return null;

          return (
            <Box key={index} w="100%">
              <Flex justify="space-between" align="center" mb={2}>
                <KText size="sm-medium" color="secondary-700">
                  {image.title}
                </KText>
                <Link
                  href={image.src}
                  target="_blank"
                  rel="noopener noreferrer"
                  color="blue.500"
                  fontSize="sm"
                  display="flex"
                  alignItems="center"
                  gap={1}
                >
                  View Full Size <LinkExternal01 size={14} />
                </Link>
              </Flex>
              <Image
                src={image.src}
                alt={image.title}
                maxW="300px"
                maxH="200px"
                objectFit="contain"
                border="1px"
                borderColor="gray.300"
                borderRadius="md"
                bg="white"
              />
            </Box>
          );
        })}
      </VStack>
    </Box>
  );
};